import { createContext, ReactNode, useState } from "react";
import { safeLocalStorage } from "../utils/safeLocalStroage.ts";

// Define the types for the context value
interface PageContextType {
  pageSize: number;
  changePageSize: (pageSize: number) => void;
}

function initPageSize(): number {
  const pageSize = safeLocalStorage.getItem("pageSize");
  if (pageSize) return Number(JSON.parse(pageSize));
  return 12;
}

// Create the context with default values
export const PageSizeContext = createContext<PageContextType>({
  pageSize: 12,
  changePageSize: () => {
    console.warn("setPageSize before init");
  },
});

interface PageProviderProps {
  children: ReactNode;
}

export const PageSizeProvider = ({ children }: PageProviderProps) => {
  const [pageSize, setPageSize] = useState<number>(initPageSize());

  const changePageSize = (pageSize: number) => {
    setPageSize(pageSize);
    safeLocalStorage.setItem("pageSize", JSON.stringify(pageSize));
  };

  return (
    <PageSizeContext.Provider
      value={{
        pageSize: pageSize,
        changePageSize: changePageSize,
      }}
    >
      {children}
    </PageSizeContext.Provider>
  );
};
